// import "@hotwired/turbo-rails"
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'


import 'slick-carousel'

import 'lazysizes'

import '../javascripts/sp_nav'
import '../javascripts/sticky_header'
import '../javascripts/sticky_footer'
import '../javascripts/accordion'
// import '../javascripts/adviser_popup_banner'
import '../javascripts/disabled_controller'
import '../javascripts/chart'
import '../javascripts/slider'
import '../javascripts/lazysizes'
import '../javascripts/time-table'
// import '../javascripts/path_select'
// import '../javascripts/company_bar_chart'

// Turbo.session.drive = false;

const application = Application.start()
const controllers = import.meta.glob('../main/js/controllers/**/*_controller.js', { eager: true });
registerControllers(application, controllers);
